<template>
  <b-form-group :label="label">
    <multiselect
      :value="computedValue"
      :options="year"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      placeholder="Selecione"
      label="id"
      track-by="id"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @select="callback"
    >
      <template slot="tag" slot-scope="{ option }">
        <span class="custom__tag">
          <span>{{ option.name }}</span>
        </span>
      </template>
      <template slot="clear" slot-scope="props">
        <div
          class="multiselect__clear"
          @mousedown.prevent.stop="clearAll(props.search)"
        ></div>
      </template>
      <span slot="noResult">Nada encontrado</span>
    </multiselect>
  </b-form-group>
</template>

<script>
export default {
  props: ["value", "label", "callback", "creation", "cycleId"],
  computed: {
    year() {
      return !this.creation || [4, 5].includes(this.cycleId)
        ? [{ id: 1 }, { id: 2 }, { id: 3 }]
        : [{ id: 1 }, { id: 2 }];
    },
    computedValue() {
      if (typeof this.value === "number") {
        return this.year.find((c) => c.id == this.value);
      } else {
        return this.value;
      }
    },
  },
};
</script>
